export type PaginationStyle = 'default' | 'simple';

export interface FilterParameter {
  property: String;
  operator: String;
  value: String | undefined;
}

interface PaginationFilter {
  key: string | null;
  filter?: Array<FilterParameter>;
  paginationStyle?: PaginationStyle;
  sortByOrder?: 'ASC' | 'DESC';
  sortByProperty?: string;
  initPageSize?: number;
  suspense?: boolean;
}

export const resolvePaginatedPath = ({
  key,
  filter = [],
  sortByOrder,
  sortByProperty,
  initPageSize = 25,
  page = 0
}: PaginationFilter & { page?: number }) => {
  const filterQueryString = filter
    .filter((f) => !!f.value)
    .reduce(
      (queryString, filter, index, array) =>
        `${index === 0 ? '&filter=' : ''}${queryString}${filter.property}_${
          filter.operator
        }_${encodeURIComponent(String(filter.value))}${index !== array.length - 1 ? ',' : ''}`,
      ''
    );

  const sortQueryString = sortByProperty
    ? `&orderBy=${sortByOrder === 'DESC' ? '-' : ''}${sortByProperty}`
    : '';

  const queryString = filterQueryString + sortQueryString;

  return `${key}?page=${page}&size=${initPageSize}${queryString}`;
};
